import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from "react-redux";
import "./OfferLayout.scss"
import _ from 'lodash';
import { v4 as uuidv4 } from 'uuid';
import { getCurrencyFormat, getLocalStorageData, LOCAL_STORAGE_ITEMS_NAMES, setLocalStorageData } from "../../../../../RestaurantWidget/utilities/helper/helper";
import { addToCart, deleteCartItem, getCartItemsToCart, updateCartItemQuantity } from "../../../../../RestaurantWidget/utilities/api/restaurantsService";
import deal from "../../../../assets/deal.png"
import check from "../../../../assets/check.svg"
import arrowBlack from "../../../../assets/arrow-black.svg"
import heart from "../../../../assets/fvrt.svg"
import fvrt from "../../../../assets/heart.svg"
import { useHistory } from 'react-router-dom';
import { addData, getAllData, setOrderCartItems, setOrderData, setOrderEmpty, setRestaurantMenuData } from '../../../../../../../../../redux/resturantWidgetSlice';
import star from "../../../../assets/star.svg"
import spiceImage from "../../../../assets/spice.svg"


import IMAGE_PLACEHOLDER from "../../../../assets/images/Images/empty-placeholder.png"
import { addItemToWishList } from '../../../../../../../utilities/apiRequests/witmegRetailPaxServerRequests';
import { setSelectedOffer } from '../../../../../../../../../redux/companyDataSlice';

const OfferLayout = ({ layout, headerText, onClick, items, showHeader, limited = true, setItems }) => {
    const history = useHistory();



    const dispatch = useDispatch()
    const { currency, orderCartData,
    } = useSelector((state) => state.resturantData);
    const currencyFormat = getCurrencyFormat(currency);
    const [data, setData] = useState(null)
    useEffect(() => {
        getAllData().then((result) => {
            setData(result);
        });
    }, []);
    let categories = data ? data?.Categories : []
    let dataItems = data ? data?.Items : []

    const selectedOrderType = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA) && JSON.parse(localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA)).selectedOrderType
    const getThePrice = (price) => {
        let priceValue;

        switch (selectedOrderType) {
            case "delivery":
                priceValue = price?.DeliveryPrice;
                break;
            case "table":
                priceValue = price?.TablePrice;
                break;
            default:
                priceValue = price?.PickupPrice;
                break;
        }
        return currencyFormat(priceValue / 100);
    };
    const getPromoPrice = (price) => {
        let priceValue;
        switch (selectedOrderType) {
            case "delivery":
                priceValue = price?.Delivery;
                break;
            case "table":
                priceValue = price?.DineIn;
                break;
            default:
                priceValue = price?.Takeaway;
                break;
        }
        return "Save " + currencyFormat(priceValue / 100);
    };
    const getPromoPercentage = (PercentageValue) => {
        let value;
        switch (selectedOrderType) {
            case "delivery":
                value = PercentageValue?.Delivery;
                break;
            case "table":
                value = PercentageValue?.DineIn;
                break;
            default:
                value = PercentageValue?.Takeaway;
                break;
        }
        return value + "% OFF"
    };
    const findItemCountFromCart = (menuItem) => {
        let isAvailable = 0
        if (!orderCartData?.Items) {
            return 0
        }
        if (orderCartData?.Items?.length === 0) {
            return 0
        }
        else {
            let found = orderCartData?.Items?.filter((item) => item?.CartItemID === menuItem?.MenuItemID)
            isAvailable = found.length
        }
        return isAvailable

    }
    const findItemFromCart = (menuItem) => {
        let isAvailable = null
        if (!orderCartData?.Items) {
            return isAvailable
        }
        if (orderCartData?.Items?.length === 0) {
            return isAvailable
        }
        else {
            let found = orderCartData?.Items?.filter((item) => item?.CartItemID === menuItem?.MenuItemID)[0]
            isAvailable = found
        }
        return isAvailable

    }

    const handleWishlist = async (item) => {
        if (item) {
            const val = await getLocalStorageData(LOCAL_STORAGE_ITEMS_NAMES.ECOM_CART_DATA);
            let category = categories?.find(cat =>
                cat.MenuEntities.some(catOBJ => catOBJ.ID === item?.MenuItemID)
            );
            let updatedItems = dataItems.map((itemval) =>
                itemval.MenuItemID === item.MenuItemID
                    ? { ...itemval, IsFavourite: !item.IsFavourite }
                    : itemval
            );

            let menu = await getAllData();
            let updated = {
                ...menu,
                data: {
                    ...menu.data,
                    Items: updatedItems
                }
            };
            await addData(updated);
            dispatch(setRestaurantMenuData({ mainMenuData: updated.data }))
            if (setItems) {
                setItems(updatedItems)
            }
            if (category) {
                let data = {
                    "ProductName": item?.Title?.en,
                    "ProductID": item?.MenuItemID,
                    "MenuID": category?.MenuID,
                    "SubMenuID": category?.MenuCategoryID,
                    "StoreID": val?.cloudLocationID,
                    "IsLikedByCustomer": !item?.IsFavourite
                }
                const userId = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID);
                await addItemToWishList(data, userId).then((response) => {
                    if (response) {

                    }
                })
            }
        }
    }
    const renderSpiceImages = (level) => {
        const fullImages = Math.floor((level * 2) / 2);
        const hasHalfImage = ((level * 2) % 2) !== 0;
        const images = Array.from({ length: fullImages }, (_, index) => (
            <img key={index} src={spiceImage} alt="spice-level" style={{ width: '16px' }} />
        ));
        if (hasHalfImage) {
            images.push(
                <span key="half" style={{ display: 'flex', width: '10px', overflow: 'hidden' }}>
                    <img src={spiceImage} alt="half-spice-level" style={{ width: '16px' }} />
                </span>
            );
        }

        return images;
    };
    const renderLayout = (menuItem) => {
        let isModifierAvailable = menuItem?.ModifierGroupRules?.IDs?.filter((ID) => ID !== "")?.length > 0
        const item = findItemFromCart(menuItem)
        const itemcount = findItemCountFromCart(menuItem)
        const offer = menuItem?.HasPromotions
            ? menuItem.ApplicablePromotions.find((promo) => promo.PromotionType === "FLATOFF") ? getPromoPrice(menuItem.ApplicablePromotions.find((promo) => promo.PromotionType === "FLATOFF")?.DiscountValue) : menuItem.ApplicablePromotions.find((promo) => promo.PromotionType === "PERCENTOFF") ?
                getPromoPercentage(menuItem.ApplicablePromotions.find((promo) => promo.PromotionType === "PERCENTOFF").PercentageValue) : "" || ""
            : "";
        return (
            <div className="column">
                <div className="item-details">
                    <div className="item-dela-cont">

                        <img alt="" src={menuItem?.ImageURL ? menuItem.ImageURL : IMAGE_PLACEHOLDER} className="item-image"

                        />
                        {
                            menuItem?.HasPromotions &&
                            <div className='discount-tag'>{menuItem?.ApplicablePromotions.length > 1 ? `${menuItem?.ApplicablePromotions.length} Offers Available` : offer
                            }</div>

                        }

                        {localStorage.getItem('isLogged') && localStorage.getItem('isLogged') === 'true' && <div className='fvrt-cont'
                            onClick={() => {
                                handleWishlist(menuItem)
                            }}>
                            <img alt="" src={menuItem?.IsFavourite ? fvrt : heart} className='fvrt-icon' />
                        </div>}
                        {/* {menuItem?.MetaData?.IsDealProduct && <div className="dea-cont "> <img alt="" src={deal} className="deal" /></div>} */}
                        {itemcount > 0 && <div className='added-btn'>
                            <img alt="" src={check} />
                            {isModifierAvailable ? itemcount : (item?.Quantity.Amount || 0)}  - Added to cart
                        </div>}
                    </div>
                    <div className="item-des">
                        <div className="item-des-title">
                            <div className='mob-name'><div className="name">{menuItem?.Title?.en?.toCapitalFirst().replace(/\.+$/, '')}
                            </div>
                                {itemcount > 0 && <div className='added-btn-mob'>
                                    {isModifierAvailable ? itemcount : (item?.Quantity.Amount || 0)}
                                </div>}
                            </div>
                        </div>
                        <div className='det-cont-wrap'>
                            <div className='dev-left'>
                                <div className='review-cont'>
                                    <img alt='' className='rev-star' src={star} />
                                    <div className='revi-per'>{menuItem?.AggregatedProductRating}</div>
                                    <div className='rev-count'>({menuItem?.TotalReviews})</div>
                                </div>
                                {menuItem?.DishInfo?.Classifications?.SpiceLevel > 0 && <div className="spice-leve-img">{renderSpiceImages(menuItem?.DishInfo.Classifications.SpiceLevel)}</div>}

                            </div>
                            <div className='dev-right'>
                                {menuItem?.DishInfo?.Classifications?.IsVegetarian && <div className="spe-cont">Vegetarian</div>}
                                {menuItem?.DishInfo?.Classifications?.IsHalal && <div className="spe-cont">Halal</div>}

                            </div>
                        </div>
                        <div className="details">{menuItem?.Description?.en?.toCapitalFirst()}</div>
                        <div className="price">
                            {menuItem?.HasPromotions ?
                                menuItem?.ApplicablePromotions[0] ? getThePrice(menuItem?.ApplicablePromotions[0]?.DiscountedPrices) : ""
                                : getThePrice(menuItem?.PriceInfo?.Price)}
                            <div className='old-price-val'>{menuItem?.HasPromotions ?
                                getThePrice(menuItem?.PriceInfo?.Price) : ""}</div>
                        </div>
                        <div className="add-to-cart-btn" onClick={() => {
                            dispatch(setSelectedOffer(menuItem.MenuItemID + "/new"))
                        }}>Order Now</div>
                    </div>
                </div>

            </div>
        )
    }


    return (
        <div className="Hospitality-navbar-Offer-Layout-Menu">
            {showHeader && <div className='textheader-container'>
                <div className="title-menu-2" >{headerText || ""}</div>
                {limited && <div className='view-all-container'
                    onClick={onClick}
                >   <div className='view-all-text'>View All</div>
                    <img alt='' src={arrowBlack} className='icon' /></div>}
            </div>}
            <div className={layout}>
                {items.map(((menuItem, key) => {
                    return (
                        <div className="column-styles" key={key}>
                            {renderLayout(menuItem)}
                        </div>
                    )
                }))}
            </div>
        </div >
    )
}
export default OfferLayout